export default {
  'managerialInvoicing.label.reportType': 'Selecione o tipo de relatório',

  'managerialInvoicing.option.realXFiscal': 'Real x Fiscal',
  'managerialInvoicing.option.realXTicket': 'Real x Passagem x Ticket Médio',
  'managerialInvoicing.option.avgTicket': 'Ticket Médio (Peças x Serviços)',
  'managerialInvoicing.option.realXpayment': 'Real x Pagamento x Recebimentos',
};
